import { forwardRef } from "react";

import MuiIconButton, { type IconButtonProps } from "@mui/material/IconButton";

import InfoIcon from "./InfoIcon";
import InfoIconSmall from "./InfoIconSmall";

// eslint-disable-next-line react/display-name
export const InfoButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { size } = props;
    const Icon = size === "small" ? InfoIconSmall : InfoIcon;
    return (
      <MuiIconButton
        aria-label="Additional information"
        type="button"
        ref={ref}
        {...props}
        size="large">
        <Icon />
      </MuiIconButton>
    );
  }
);

export default InfoButton;
